"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Token = void 0;
class Token {
    constructor(type, lexeme, literal, line, start, end) {
        this.type = type;
        this.lexeme = lexeme;
        this.literal = literal;
        this.line = line;
        this.start = start;
        this.end = end;
        this.type = type;
        this.lexeme = lexeme;
        this.literal = literal;
        this.line = line;
        this.start = start;
        this.end = end;
    }
    setNext(token) {
        this.next = token;
    }
    getNext() {
        return this.next;
    }
    toSource() {
        return this.lexeme + (this.next?.toSource() ?? '');
    }
}
exports.Token = Token;
//# sourceMappingURL=token.js.map